import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import useMeasure from 'react-use-measure';

export { animated };

export function useCollapseAnimation(visible: boolean, enabled = true) {
  const [measureRef, { height }] = useMeasure({ scroll: true });

  const [props] = useSpring(
    {
      visibility: visible ? 'visible' : 'hidden',
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0px)' : 'translateY(-20px)',
      pointerEvents: visible ? 'all' : 'none',
      height: visible ? height : 0,
      immediate: !enabled,
      delay: !enabled ? 0 : 150
    },
    [visible, height, enabled]
  );

  return {
    props: props as unknown as React.CSSProperties,
    measureRef
  };
}
